import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNews } from "@/hooks/content";
import { useTranslatedList } from "@/hooks/useTranslatedList";

export default function LatestNewsSection() {
  const { t } = useTranslation();
  const { items: articles } = useNews();
  const latestNews = useTranslatedList(articles, ["headline", "excerpt", "category"])
    .filter((a) => a.status === "published")
    .slice(0, 4);

  return (
    <section className="bg-white py-12 md:py-16">
      <div className="ltv-container">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-8">
          <h2 className="ltv-section-title mb-0">{t("home.latestNews")}</h2>
          <Link
            to="/news"
            className="inline-flex items-center gap-1 text-sm font-semibold text-accent-500 hover:text-accent-600 transition-colors whitespace-nowrap"
          >
            {t("home.viewAllNews")}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {latestNews.map((article) => (
            <Link
              key={article.id}
              to={`/news/${article.slug}`}
              className="ltv-card group hover:border-accent-200 transition-all"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.headline}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-primary-500 text-white text-xs font-semibold px-2 py-1 rounded">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors">
                  {article.headline}
                </h3>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{new Date(article.publishedAt).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}